var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        node: true,
        root: _vm.isRoot || !_vm.show,
        "node-error-state": _vm.showError,
      },
    },
    [
      _vm.show
        ? _c(
            "div",
            {
              class: {
                "node-body": true,
                error: _vm.showError,
                "node-body-disabled": _vm.isProcess && _vm.title == "发起人",
              },
              style: { "background-color": _vm.headerBgc },
              on: { click: _vm.onSelected },
            },
            [
              _c("div", [
                _c("div", { staticClass: "node-body-header" }, [
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  !_vm.isRoot && _vm.$store.state.diagramMode !== "viewer"
                    ? _c("i", {
                        staticClass: "el-icon-close",
                        staticStyle: { float: "right" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("delNode")
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  { staticClass: "node-body-content" },
                  [
                    _vm.leftIcon ? _c("i", { class: _vm.leftIcon }) : _vm._e(),
                    (_vm.content || "").trim() === ""
                      ? _c("span", { staticClass: "placeholder" }, [
                          _vm._v(_vm._s(_vm.placeholder)),
                        ])
                      : _c("ellipsis", {
                          attrs: { row: 2, content: _vm.content },
                        }),
                    _vm.$store.state.diagramMode !== "viewer"
                      ? _c("i", { staticClass: "el-icon-arrow-right" })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.showError
                  ? _c(
                      "div",
                      { staticClass: "node-error" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: _vm.errorInfo,
                              placement: "top-start",
                            },
                          },
                          [_c("i", { staticClass: "el-icon-warning-outline" })]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "node-footer" }, [
        _c(
          "div",
          { staticClass: "btn" },
          [
            _c("insert-button", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$store.state.diagramMode !== "viewer",
                  expression: "$store.state.diagramMode !== 'viewer'",
                },
              ],
              on: { insertNode: (type) => _vm.$emit("insertNode", type) },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }